<template>
  <div class="login">
   <h1>Hello,<span class="username">{{account}}</span></h1>
   <form>
     <!-- 用户名 -->
     <div class="login-input">
       <div>Username</div>
       <input type="text" v-model='account'>
     </div>
     <!-- 用户密码 -->
     <div class="login-input">
       <div>Password</div>
       <input type="password" v-model='password'>
     </div>
     <!-- 找回密码登录 -->
     <div class="login-other">
       <div style="cursor:pointer"><span><a @click="password=''">{{$store.state.module1.isChina?'重置密码':'reset'}}</a></span></div>
       <div><button class="loin-btn" @click.prevent="log()">Login</button></div>
     </div>
   </form>
   <slot></slot>
   <div style="marginTop:1.5rem;"> Copyright  上海迪勤智能科技有限公司 保留所有权利 | <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备18020448号</a></div>
  </div>
</template>

<script>
import { stringTime, requestData } from '../../assets/js/commont.js'
import { Mixin } from '../../mixins/index.js'
export default {
  name: 'Log',
  mixins: [Mixin],
  data () {
    return {
      account: '',
      password: ''
    }
  },
  methods: {
    log () {
      if (this.account.trim() && this.password.trim()) {
        var time = stringTime(this.$myTime())
        var data = {
          account: this.account,
          password: this.password,
          ts: time
        }
        // 登录
        this.login(requestData(data)).then((res) => {
          window.localStorage.setItem('token', res.data.data.token)
          if (res.data.data.is_freshair === 1) {
            window.localStorage.setItem('isAir', 1)
            this.$store.commit('setAir', true)
          }
          this.$message({
            message: this.$store.state.module1.isChina ? '登录成功' : 'login success',
            type: 'success'
          })
          // 保存用户名
          window.localStorage.setItem('account', this.account)
          if (res.data.data.longitude && res.data.data.latitude) {
            window.localStorage.setItem('center', JSON.stringify({
              lng: res.data.data.longitude,
              lat: res.data.data.latitude
            }))
          }
          var time1 = stringTime(this.$myTime())
          var data1 = {
            account: window.localStorage.getItem('account'),
            is_all: 1,
            token: res.data.data.token,
            ts: time1
          }
          setTimeout(() => {
            // 获取项目列表
            this.getProjectList(requestData(data1))
            this.$router.push('/home')
          }, 1000)
        },
        rea => {
          this.$message({
            message: this.$store.state.module1.isChina ? '用户名或密码不正确' : 'userName or password is wrong',
            type: 'warning'
          })
        })
      } else {
        this.$message({
          message: this.$store.state.module1.isChina ? '用户名或密码不可以为空' : 'userName or password cant not be empty',
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style scoped>
h1{
height:0.48rem;
font-size: 0.32rem;
font-family: DINPro;
font-weight: 900;
text-align: left;
color: #1d2d4e;
line-height:0.48rem;
margin-left:0.2rem;
margin-bottom:0.6rem;
}
.login{
  text-align:left;
}
.username{
  color:#01A3FF;
}
.login-input{
  width:100%;
  height:0.74rem;
  background:white;
  border-radius:0.16rem;
  margin-bottom:0.24rem;
  display:flex;
  flex-direction:column;
  padding:0.12rem 0.32rem;
  box-shadow:0 0.05rem 5px rgba(0,0,0,0.05);
}
.login-input div{
  width: 0.32rem;
height:0.18rem;
opacity: 0.8;
font-size: 0.14rem;
font-family: PingFangSC, PingFangSC-Medium;
font-weight: 500;
text-align: left;
color: #1d2d4e;
line-height: 0.18rem;
margin-bottom:0.04rem;
}
.login-input input{
  width:60%;
  height:0.22rem;
  font-size:0.18rem;
}
.login-other{
  margin-top:0.48rem;
  height:0.52rem;
  display:flex;
  justify-content:space-between;
  align-items:center;
  color:#1d2d4e;
  font-weight: 600;
  padding:0 0.16rem;
}
.loin-btn{
  height:0.52rem;
  width:1.92rem;
  color:white;
  background: #01A3FF;
  border-radius: 0.16rem;
  cursor: pointer;
}
.login-other span{
  opacity:0.6;
}
.login-other span a{
 color:#01A3FF;
 text-decoration: underline;
}
</style>
